import { Skeleton, Table, Text } from '@mantine/core';

const SkeletonTable = ({
  headers,
  rows = 10
}: {
  headers: Array<{ label: string; key: string }>;
  rows?: number;
}) => {
  return (
    <Table>
      <Table.Thead>
        <Table.Tr>
          {headers.map((header) => (
            <Table.Th py={'xs'} key={header.key}>
              <Text size={'sm'} fw={'600'} c={'gray.8'}>
                {header.label}
              </Text>
            </Table.Th>
          ))}
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <Table.Tr key={rowIndex}>
            {Array.from({ length: headers.length }).map((_, colIndex) => (
              <Table.Td key={colIndex} py={'xs'}>
                <Skeleton height={12} width="80%" />
              </Table.Td>
            ))}
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  );
};

export default SkeletonTable;
